import { useState, useEffect } from 'react'
import { Sun, Moon } from 'react-bootstrap-icons'
import { Container, Navbar, Nav } from 'react-bootstrap'
import mail from '../assets/img/mailbox2.svg'
import linkedin from '../assets/img/linkedin.svg'
import github from '../assets/img/github.svg'
import whatsapp from '../assets/img/whatsapp.svg'

import logo from '../assets/img/logo.png'
import { useTranslation } from 'react-i18next';

const GLOW_COLORS = ['#31fff5','#7c3aed','#f472b6','#fbbf24','#34d399','#60a5fa','#ff6b6b','#ffd93d'];

function NavBar() {
    const { t } = useTranslation();
    const [activeLink, setActiveLink] = useState('home')
    const [scrolled, setScrolled] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark')

    const glowEnter = (e) => {
        const c1 = GLOW_COLORS[Math.floor(Math.random() * GLOW_COLORS.length)];
        const c2 = GLOW_COLORS[Math.floor(Math.random() * GLOW_COLORS.length)];
        e.currentTarget.style.setProperty('--gc1', c1);
        e.currentTarget.style.setProperty('--gc2', c2);
    };

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true)
            } else {
                setScrolled(false)
            }
        }
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [])

    useEffect(() => {
        if (theme === 'light') {
            document.body.classList.add('light-theme');
        } else {
            document.body.classList.remove('light-theme');
        }
        localStorage.setItem('theme', theme);
    }, [theme])

    const toggleTheme = () => {
        setTheme(theme === 'dark' ? 'light' : 'dark')
    }

    function onUpdateActiveLink(value) {
        setActiveLink(value)
        setDropdownOpen(false)
    }

    return (
        <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
            <Container>
                <Navbar.Brand href="#footer">
                    <span className="logo-glitch-wrap"><div className="efecto-glitch"><img src={logo} alt="Facundo Corona logo" /></div></span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className={"navbar-toggler-icon"}></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>{t('nav.home')}</Nav.Link>
                        <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>{t('nav.skills')}</Nav.Link>

                        <div
                            className={`nav-dropdown-wrapper${dropdownOpen ? ' open' : ''}`}
                            onMouseEnter={() => setDropdownOpen(true)}
                            onMouseLeave={() => setDropdownOpen(false)}
                        >
                            <Nav.Link
                                href="#experience"
                                className={activeLink === 'experience' ? 'active navbar-link nav-dropdown-title' : 'navbar-link nav-dropdown-title'}
                                onClick={(e) => {
                                    if (window.innerWidth <= 991) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setDropdownOpen(prev => !prev);
                                    } else {
                                        onUpdateActiveLink('experience');
                                    }
                                }}
                            >
                                {t('nav.experience')} <span className="nav-dropdown-arrow">&#9660;</span>
                            </Nav.Link>
                            <div className="nav-dropdown-menu">
                                <a href="#project" className="nav-dropdown-item" onClick={() => onUpdateActiveLink('projects')}>
                                    {t('nav.projects')}
                                </a>
                                <a href="#apps" className="nav-dropdown-item" onClick={() => onUpdateActiveLink('apps')}>
                                    {t('nav.apps')}
                                </a>
                            </div>
                        </div>

                        <Nav.Link href="#connect" className={activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('contact')}>{t('nav.contact')}</Nav.Link>
                    </Nav>
                    <span className={"navbar-text"}>
                        <div className={"social-icon"}>
                            <a className='correo' onMouseEnter={glowEnter} href={"mailto:coronafacundo@gmail.com"} target="_blank" rel="noopener noreferrer"><img src={mail} alt={'Email'} width="24" height="24" loading="lazy" /></a>
                            <a className='linkedin' onMouseEnter={glowEnter} href={"https://www.linkedin.com/in/facucorona/"} target="_blank" rel="me noopener noreferrer"><img src={linkedin} alt={'LinkedIn'} width="24" height="24" loading="lazy" /></a>
                            <a className='github' onMouseEnter={glowEnter} href={"https://github.com/facucorona"} target="_blank" rel="me noopener noreferrer"><img src={github} alt={'GitHub'} width="24" height="24" loading="lazy" /></a>
                            <a className='whatsapp' onMouseEnter={glowEnter} target="_blank" href={`https://api.whatsapp.com/send?phone=+543515932204&text=Hi, I clicked the Whatsapp icon in your Portfolio. I'd like to contat personally with You. Let me know when You're free to chat. Thanks, greets.`} rel="noopener noreferrer">
                                <img src={whatsapp} alt={'WhatsApp'} width="24" height="24" loading="lazy" />
                            </a>
                        </div>
                        <div className="theme-switch-container">
                            <label className="theme-switch" aria-label={t('theme.toggle')} title={t('theme.toggle')}>
                                <input type="checkbox" checked={theme === 'light'} onChange={toggleTheme} aria-label={t('theme.toggle')} aria-checked={theme === 'light'} role="switch" />
                                <span className="slider round" aria-hidden="true">
                                    <Sun className="icon sun" />
                                    <Moon className="icon moon" />
                                </span>
                            </label>
                        </div>
                        <a href="#connect">
                            <button className={"vvd"} onClick={() => { console.log("connect") }}><span>{t('nav.connect')}</span></button>
                        </a>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBar
